// Generated by scripts/check/gate/check_shared_platform_public_endpoints.py. Do not edit manually.

export const IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS = {
  "airange-account": {
    domainHost: null,
    domainPrefix: "account",
    domainPath: "/",
    ipPath: "/account",
    publicUrlEnv: "AIRANGE_ACCOUNT_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AIRANGE_ACCOUNT_URL",
      "VITE_AIRANGE_ACCOUNT_URL",
      "AIRANGE_ACCOUNT_URL",
    ],
  },
  "airange-admin": {
    domainHost: null,
    domainPrefix: "admin",
    domainPath: "/",
    ipPath: "/admin",
    publicUrlEnv: "AIRANGE_ADMIN_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AIRANGE_ADMIN_URL",
      "VITE_AIRANGE_ADMIN_URL",
      "AIRANGE_ADMIN_URL",
    ],
  },
  "airange-environment": {
    domainHost: null,
    domainPrefix: "env",
    domainPath: "/",
    ipPath: "/environment",
    publicUrlEnv: "ENVIRONMENT_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_ENVIRONMENT_BASE_URL",
      "VITE_ENVIRONMENT_BASE_URL",
      "ENVIRONMENT_BASE_URL",
    ],
  },
  "airange-portal": {
    domainHost: "root",
    domainPrefix: null,
    domainPath: "/",
    ipPath: "/",
    publicUrlEnv: "AIRANGE_PORTAL_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AIRANGE_PORTAL_URL",
      "VITE_AIRANGE_PORTAL_URL",
      "AIRANGE_PORTAL_URL",
    ],
  },
  "airange-remote": {
    domainHost: null,
    domainPrefix: "remote",
    domainPath: "/",
    ipPath: "/remote",
    publicUrlEnv: "AIRANGE_REMOTE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AIRANGE_REMOTE_URL",
      "VITE_AIRANGE_REMOTE_URL",
      "AIRANGE_REMOTE_URL",
    ],
  },
  "airange-space": {
    domainHost: null,
    domainPrefix: "space",
    domainPath: "/",
    ipPath: "/space",
    publicUrlEnv: "AIRANGE_SPACE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AIRANGE_SPACE_URL",
      "VITE_AIRANGE_SPACE_URL",
      "AIRANGE_SPACE_URL",
    ],
  },
  "aitest-api": {
    domainHost: null,
    domainPrefix: "aitest",
    domainPath: "/api",
    ipPath: "/aitest-api",
    publicUrlEnv: "AITEST_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AITEST_API_PUBLIC_URL",
      "VITE_AITEST_API_PUBLIC_URL",
      "AITEST_API_PUBLIC_URL",
    ],
  },
  "aitest-plus-web": {
    domainHost: null,
    domainPrefix: "aitest-plus",
    domainPath: "/",
    ipPath: "/aitest-plus",
    publicUrlEnv: "AITEST_PLUS_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_AITEST_PLUS_BASE_URL",
      "VITE_AITEST_PLUS_BASE_URL",
      "AITEST_PLUS_BASE_URL",
    ],
  },
  "aitest-web": {
    domainHost: null,
    domainPrefix: "aitest",
    domainPath: "/",
    ipPath: "/aitest",
    publicUrlEnv: "AITEST_BASE_URL",
    publicOriginEnv: "AITEST_PUBLIC_BASE_URL",
    envKeys: [
      "UMI_APP_AITEST_BASE_URL",
      "VITE_AITEST_BASE_URL",
      "AITEST_BASE_URL",
    ],
  },
  "asset-center": {
    domainHost: null,
    domainPrefix: "assets",
    domainPath: "/",
    ipPath: "/asset",
    publicUrlEnv: "ASSET_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_ASSET_BASE_URL",
      "VITE_ASSET_BASE_URL",
      "ASSET_BASE_URL",
    ],
  },
  "ctf-admin": {
    domainHost: null,
    domainPrefix: "ctf-admin",
    domainPath: "/",
    ipPath: "/ctf-admin",
    publicUrlEnv: "CTF_ADMIN_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_CTF_ADMIN_BASE_URL",
      "VITE_CTF_ADMIN_BASE_URL",
      "CTF_ADMIN_BASE_URL",
    ],
  },
  "ctf-api": {
    domainHost: null,
    domainPrefix: "ctf",
    domainPath: "/api",
    ipPath: "/ctf/api",
    publicUrlEnv: "CTF_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_CTF_API_PUBLIC_URL",
      "VITE_CTF_API_PUBLIC_URL",
      "CTF_API_PUBLIC_URL",
    ],
  },
  "ctf-forgejo": {
    domainHost: null,
    domainPrefix: "ctfhub",
    domainPath: "/",
    ipPath: "/ctfhub",
    publicUrlEnv: "CTF_FORGEJO_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_CTF_FORGEJO_BASE_URL",
      "VITE_CTF_FORGEJO_BASE_URL",
      "CTF_FORGEJO_BASE_URL",
    ],
  },
  "ctf-portal": {
    domainHost: null,
    domainPrefix: "ctf",
    domainPath: "/",
    ipPath: "/ctf",
    publicUrlEnv: "CTF_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_CTF_BASE_URL",
      "VITE_CTF_BASE_URL",
      "CTF_BASE_URL",
    ],
  },
  "edu-admin": {
    domainHost: null,
    domainPrefix: "edu-admin",
    domainPath: "/",
    ipPath: "/edu-admin",
    publicUrlEnv: "EDU_ADMIN_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EDU_ADMIN_BASE_URL",
      "VITE_EDU_ADMIN_BASE_URL",
      "EDU_ADMIN_BASE_URL",
    ],
  },
  "edu-api": {
    domainHost: null,
    domainPrefix: "edu",
    domainPath: "/api",
    ipPath: "/edu/api",
    publicUrlEnv: "EDU_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EDU_API_PUBLIC_URL",
      "VITE_EDU_API_PUBLIC_URL",
      "EDU_API_PUBLIC_URL",
    ],
  },
  "edu-portal": {
    domainHost: null,
    domainPrefix: "edu",
    domainPath: "/",
    ipPath: "/edu",
    publicUrlEnv: "EDU_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EDU_BASE_URL",
      "VITE_EDU_BASE_URL",
      "EDU_BASE_URL",
    ],
  },
  "exam-admin": {
    domainHost: null,
    domainPrefix: "exam-admin",
    domainPath: "/",
    ipPath: "/exam-admin",
    publicUrlEnv: "EXAM_ADMIN_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EXAM_ADMIN_URL",
      "VITE_EXAM_ADMIN_URL",
      "EXAM_ADMIN_URL",
    ],
  },
  "exam-api": {
    domainHost: null,
    domainPrefix: "exam",
    domainPath: "/api",
    ipPath: "/api",
    publicUrlEnv: "EXAM_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EXAM_API_PUBLIC_URL",
      "VITE_EXAM_API_PUBLIC_URL",
      "EXAM_API_PUBLIC_URL",
    ],
  },
  "exam-candidate": {
    domainHost: null,
    domainPrefix: "exam",
    domainPath: "/",
    ipPath: "/exam",
    publicUrlEnv: "EXAM_CANDIDATE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EXAM_CANDIDATE_URL",
      "VITE_EXAM_CANDIDATE_URL",
      "EXAM_CANDIDATE_URL",
    ],
  },
  "execution-fabric": {
    domainHost: null,
    domainPrefix: "execution",
    domainPath: "/",
    ipPath: "/exec",
    publicUrlEnv: "EXECUTION_FABRIC_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_EXECUTION_FABRIC_PUBLIC_URL",
      "VITE_EXECUTION_FABRIC_PUBLIC_URL",
      "EXECUTION_FABRIC_PUBLIC_URL",
    ],
  },
  "micro-lab-admin": {
    domainHost: null,
    domainPrefix: "micro-lab-admin",
    domainPath: "/",
    ipPath: "/micro-lab-admin",
    publicUrlEnv: "MICRO_LAB_ADMIN_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_MICRO_LAB_ADMIN_URL",
      "VITE_MICRO_LAB_ADMIN_URL",
      "MICRO_LAB_ADMIN_URL",
    ],
  },
  "micro-lab-api": {
    domainHost: null,
    domainPrefix: "micro-lab",
    domainPath: "/api",
    ipPath: "/micro-lab/api",
    publicUrlEnv: "MICRO_LAB_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_MICRO_LAB_API_PUBLIC_URL",
      "VITE_MICRO_LAB_API_PUBLIC_URL",
      "MICRO_LAB_API_PUBLIC_URL",
    ],
  },
  "micro-lab-portal": {
    domainHost: null,
    domainPrefix: "micro-lab",
    domainPath: "/",
    ipPath: "/micro-lab",
    publicUrlEnv: "MICRO_LAB_PORTAL_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_MICRO_LAB_PORTAL_URL",
      "VITE_MICRO_LAB_PORTAL_URL",
      "MICRO_LAB_PORTAL_URL",
    ],
  },
  "redblue-admin": {
    domainHost: null,
    domainPrefix: "redblue-admin",
    domainPath: "/",
    ipPath: "/redblue-admin",
    publicUrlEnv: "REDBLUE_ADMIN_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_REDBLUE_ADMIN_URL",
      "VITE_REDBLUE_ADMIN_URL",
      "REDBLUE_ADMIN_URL",
    ],
  },
  "redblue-api": {
    domainHost: null,
    domainPrefix: "redblue",
    domainPath: "/api",
    ipPath: "/redblue/api",
    publicUrlEnv: "REDBLUE_API_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_REDBLUE_API_PUBLIC_URL",
      "VITE_REDBLUE_API_PUBLIC_URL",
      "REDBLUE_API_PUBLIC_URL",
    ],
  },
  "redblue-portal": {
    domainHost: null,
    domainPrefix: "redblue",
    domainPath: "/",
    ipPath: "/redblue",
    publicUrlEnv: "REDBLUE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_REDBLUE_URL",
      "VITE_REDBLUE_URL",
      "REDBLUE_URL",
    ],
  },
  "sso-center": {
    domainHost: null,
    domainPrefix: "sso",
    domainPath: "/",
    ipPath: "/",
    publicUrlEnv: "SSO_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_SSO_BASE_URL",
      "VITE_SSO_BASE_URL",
      "SSO_BASE_URL",
    ],
  },
  "task-center": {
    domainHost: null,
    domainPrefix: "task",
    domainPath: "/",
    ipPath: "/task-center",
    publicUrlEnv: "TASK_CENTER_PUBLIC_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_TASK_CENTER_PUBLIC_URL",
      "VITE_TASK_CENTER_PUBLIC_URL",
      "TASK_CENTER_PUBLIC_URL",
    ],
  },
  "topology-editor": {
    domainHost: null,
    domainPrefix: "topology-editor",
    domainPath: "/",
    ipPath: "/topology-editor",
    publicUrlEnv: "TOPOLOGY_EDITOR_BASE_URL",
    publicOriginEnv: null,
    envKeys: [
      "UMI_APP_TOPOLOGY_EDITOR_BASE_URL",
      "VITE_TOPOLOGY_EDITOR_BASE_URL",
      "TOPOLOGY_EDITOR_BASE_URL",
    ],
  },
} as const;

export const IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS = {
  "business-reference-center": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/business-reference-center",
    publicUrlEnv: "BUSINESS_REFERENCE_CENTER_PUBLIC_URL",
    envKeys: [
      "UMI_APP_BUSINESS_REFERENCE_CENTER_PUBLIC_URL",
      "VITE_BUSINESS_REFERENCE_CENTER_PUBLIC_URL",
      "BUSINESS_REFERENCE_CENTER_PUBLIC_URL",
    ],
  },
  "capability-graph": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/capability-graph",
    publicUrlEnv: "CAPABILITY_GRAPH_PUBLIC_URL",
    envKeys: [
      "UMI_APP_CAPABILITY_GRAPH_PUBLIC_URL",
      "VITE_CAPABILITY_GRAPH_PUBLIC_URL",
      "CAPABILITY_GRAPH_PUBLIC_URL",
    ],
  },
  "intelligence-center": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/intelligence",
    publicUrlEnv: "INTELLIGENCE_CENTER_PUBLIC_URL",
    envKeys: [
      "UMI_APP_INTELLIGENCE_CENTER_PUBLIC_URL",
      "VITE_INTELLIGENCE_CENTER_PUBLIC_URL",
      "INTELLIGENCE_CENTER_PUBLIC_URL",
    ],
  },
  "knowledge-library": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/knowledge-library",
    publicUrlEnv: "KNOWLEDGE_LIBRARY_PUBLIC_URL",
    envKeys: [
      "UMI_APP_KNOWLEDGE_LIBRARY_PUBLIC_URL",
      "VITE_KNOWLEDGE_LIBRARY_PUBLIC_URL",
      "KNOWLEDGE_LIBRARY_PUBLIC_URL",
    ],
  },
  "ops-center": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/ops-center",
    publicUrlEnv: "OPS_CENTER_PUBLIC_URL",
    envKeys: [
      "UMI_APP_OPS_CENTER_PUBLIC_URL",
      "VITE_OPS_CENTER_PUBLIC_URL",
      "OPS_CENTER_PUBLIC_URL",
    ],
  },
  "tactics-techniques-hub": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/tactics-techniques-hub",
    publicUrlEnv: "TACTICS_TECHNIQUES_HUB_PUBLIC_URL",
    envKeys: [
      "UMI_APP_TACTICS_TECHNIQUES_HUB_PUBLIC_URL",
      "VITE_TACTICS_TECHNIQUES_HUB_PUBLIC_URL",
      "TACTICS_TECHNIQUES_HUB_PUBLIC_URL",
    ],
  },
  "tools-library": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/tools-library",
    publicUrlEnv: "TOOLS_LIBRARY_PUBLIC_URL",
    envKeys: [
      "UMI_APP_TOOLS_LIBRARY_PUBLIC_URL",
      "VITE_TOOLS_LIBRARY_PUBLIC_URL",
      "TOOLS_LIBRARY_PUBLIC_URL",
    ],
  },
  "traffic-library": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/traffic-library",
    publicUrlEnv: "TRAFFIC_LIBRARY_PUBLIC_URL",
    envKeys: [
      "UMI_APP_TRAFFIC_LIBRARY_PUBLIC_URL",
      "VITE_TRAFFIC_LIBRARY_PUBLIC_URL",
      "TRAFFIC_LIBRARY_PUBLIC_URL",
    ],
  },
  "vulnerability-library": {
    publicMountService: "airange-admin",
    publicMountPath: "/api/vulnerability-library",
    publicUrlEnv: "VULNERABILITY_LIBRARY_PUBLIC_URL",
    envKeys: [
      "UMI_APP_VULNERABILITY_LIBRARY_PUBLIC_URL",
      "VITE_VULNERABILITY_LIBRARY_PUBLIC_URL",
      "VULNERABILITY_LIBRARY_PUBLIC_URL",
    ],
  },
} as const;

export const IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS = {
  "harbor-http": {
    publicDomainPrefix: "registry",
    publicDomainScheme: "https",
    publicIpScheme: "http",
    publicIpPath: null,
    port: 5003,
    publicHostEnv: "RUNTIME_REGISTRY_REQUIRED_HOST",
    publicHostPortEnv: "RUNTIME_REGISTRY_REQUIRED_HOST_PORT",
    publicUrlEnv: "RUNTIME_REGISTRY_BASE_URL",
    envKeys: [
      "UMI_APP_RUNTIME_REGISTRY_BASE_URL",
      "VITE_RUNTIME_REGISTRY_BASE_URL",
      "RUNTIME_REGISTRY_BASE_URL",
      "REGISTRY_BASE_URL",
      "HARBOR_BASE_URL",
    ],
  },
  "minio-api": {
    publicDomainPrefix: "drive",
    publicDomainScheme: "https",
    publicIpScheme: "http",
    publicIpPath: "/minio-api",
    port: 9000,
    publicHostEnv: "MINIO_SERVER_HOST",
    publicHostPortEnv: null,
    publicUrlEnv: "MINIO_SERVER_URL",
    envKeys: [
      "UMI_APP_MINIO_SERVER_URL",
      "VITE_MINIO_SERVER_URL",
      "MINIO_SERVER_URL",
    ],
  },
  "minio-console": {
    publicDomainPrefix: "console.drive",
    publicDomainScheme: "https",
    publicIpScheme: "http",
    publicIpPath: "/drive",
    port: 9001,
    publicHostEnv: "MINIO_CONSOLE_HOST",
    publicHostPortEnv: null,
    publicUrlEnv: "MINIO_BROWSER_REDIRECT_URL",
    envKeys: [
      "UMI_APP_MINIO_BROWSER_REDIRECT_URL",
      "VITE_MINIO_BROWSER_REDIRECT_URL",
      "MINIO_BROWSER_REDIRECT_URL",
      "MINIO_CONSOLE_BASE_URL",
    ],
  },
} as const;

export type IAiPlatformPublicServiceKey = keyof typeof IA_I_PLATFORM_PUBLIC_SERVICE_ENDPOINTS;
export type IAiPlatformMountedApiServiceKey = keyof typeof IA_I_PLATFORM_MOUNTED_API_PUBLIC_ENDPOINTS;
export type IAiPlatformPublicInfrastructureEndpointKey = keyof typeof IA_I_PLATFORM_PUBLIC_INFRASTRUCTURE_ENDPOINTS;
